// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"eaVp8":[function(require,module,exports,__globalThis) {
require("d75f83fc8dd4792f").register(require("c4646e8f182930a9").getBundleURL('gRcu1'), JSON.parse("[\"gRcu1\",\"searchBar.js\",\"e8jgw\",\"locations.en.2b9eb3d5.js\",\"h4Kzj\",\"searchBar.css\"]"));

},{"d75f83fc8dd4792f":"fyJL2","c4646e8f182930a9":"c7Tr5"}],"fyJL2":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"7mLUj":[function(require,module,exports,__globalThis) {
var _indexCss = require("./index.css");
var _locationsUtil = require("./utils/locations.util");
var _autocomplete = require("./searchBar/autocomplete");
var _domUtil = require("./utils/dom.util");
const SELECTOR_HEADER = "#menu1";
const SELECTOR_FORM = "xchange-public-leasing-search-bar-form";
const PREFILL_DATA = [
    "pickup",
    "action"
];
class SearchBar {
    constructor(el){
        this.el = el;
        this.form = this.el.querySelector(`#${SELECTOR_FORM}`);
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.init();
    }
    async init() {
        await this.initAutoComplete();
        this.prefillSearchBar();
    }
    async initAutoComplete() {
        const inputPickup = this.el.querySelector("#autocomplete-pickup");
        const inputDropoff = this.el.querySelector("#autocomplete-dropoff");
        this.autocompletePickup = new (0, _autocomplete.AutoComplete)(inputPickup, {
            src: await (0, _locationsUtil.getLocations)(),
            keys: [
                "searchLabel",
                "searchLabelAlt"
            ]
        });
        this.autocompleteDropoff = new (0, _autocomplete.AutoComplete)(inputDropoff, {
            src: await (0, _locationsUtil.getLocations)(),
            keys: [
                "searchLabel",
                "searchLabelAlt"
            ]
        });
    }
    handleSubmit(event) {
        event.preventDefault();
        const formValues = new FormData(this.form);
        const urlParams = new URLSearchParams();
        urlParams.append("direction", formValues.get("direction"));
        if (formValues.get("pickup-unlo")) urlParams.append("pickUpLocationUnlocode", formValues.get("pickup-unlo"));
        if (formValues.get("dropoff-unlo")) urlParams.append("dropOffLocationUnlocode", formValues.get("dropoff-unlo"));
        const scrollParam = this.el.dataset.scroll;
        if (scrollParam !== null) urlParams.append("scroll", "true");
        const resultPageUrl = this.el.dataset.resultPage || window.location.origin + window.location.pathname;
        window.location.href = `${resultPageUrl}?${urlParams.toString()}`;
    }
    prefillSearchBar() {
        const urlParamsFetched = this.fetchUrlParams();
        if (urlParamsFetched) // Return early if url params are set to prevent unwanted overwrite of values
        return;
        PREFILL_DATA.forEach((key)=>{
            const value = this.el.getAttribute(`data-prefill-${key}`);
            if (key === "pickup" && value) {
                const allowOverwrite = this.autocompletePickup.getSelectedLocations();
                if (!allowOverwrite) return;
                this.autocompletePickup.addChipByUnlocode(value);
            }
            if (key === "action" && value) this.setDirection(value);
        });
    }
    setDirection(direction) {
        const parsedDirection = direction === "use" ? "Using" : "Supplying";
        const directionEl = this.el.querySelector(`[name="direction"][value="${parsedDirection}"]`);
        if (directionEl) directionEl.checked = true;
    }
    /**
   * Fetch url params for prefilling the search bar
   */ fetchUrlParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const direction = urlParams.get("direction");
        const pickup = urlParams.get("pickUpLocationUnlocode");
        const dropoff = urlParams.get("dropOffLocationUnlocode");
        const scroll = urlParams.get("scroll");
        if (pickup) this.autocompletePickup.addChipByUnlocode(pickup);
        if (dropoff) this.autocompleteDropoff.addChipByUnlocode(dropoff);
        if (scroll) setTimeout(()=>{
            const headerHeight = Math.max(document.querySelector(SELECTOR_HEADER)?.clientHeight || 0, 70);
            const scrollPosition = this.el.getBoundingClientRect().top + window.scrollY - headerHeight - 32;
            window.scrollTo({
                top: scrollPosition,
                behavior: "smooth"
            });
        }, 500);
        if (direction || pickup || dropoff) return true;
        return false;
    }
}
(0, _domUtil.docReady)(()=>{
    const el = document.querySelectorAll(".xchange-public-leasing-search-bar");
    if (el) el.forEach((el)=>new SearchBar(el));
});

},{"./index.css":"fW8RG","./utils/locations.util":"hVGYE","./searchBar/autocomplete":"6KIgO","./utils/dom.util":"dQBzS"}],"fW8RG":[function() {},{}],"hVGYE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLocations", ()=>getLocations);
const getLocations = async ()=>{
    return await require("9feb840ea47cb375");
};

},{"9feb840ea47cb375":"njKss","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"njKss":[function(require,module,exports,__globalThis) {
module.exports = require("7d263669955b83b2")(require("165385e0f7a06b7").resolve("e8jgw")).then(()=>module.bundle.root('77iJd'));

},{"7d263669955b83b2":"hpx0h","165385e0f7a06b7":"fyJL2"}],"hpx0h":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"1uYxD"}],"1uYxD":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"k3151":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"6KIgO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoComplete", ()=>AutoComplete);
var _autocompleteJs = require("@tarekraafat/autocomplete.js");
var _autocompleteJsDefault = parcelHelpers.interopDefault(_autocompleteJs);
var _formatUtils = require("../utils/format.utils");
var _autocompleteStylesCss = require("../styles/autocomplete.styles.css");
const SELECTOR_TEMPLATE = "template#xchange-public-leasing-search-bar__chip__template";
const SELECTOR_CHIPS_CONTAINER = ".xchange-public-leasing-search-bar__chips";
const SELECTOR_CHIPS_ITEM = ".xchange-public-leasing-search-bar__chips__chip";
class AutoComplete {
    constructor(el, options){
        this.el = el;
        this.input = this.el.querySelector(".autocomplete-input");
        this.inputUnlo = this.el.querySelector(".autocomplete-unlo");
        this.options = options;
        this.template = document.querySelector(SELECTOR_TEMPLATE);
        this.chipsContainer = this.el.querySelector(SELECTOR_CHIPS_CONTAINER);
        this.chips = new Map();
        this.formatService = new (0, _formatUtils.FormatService)();
        this.init();
    }
    init() {
        this.formatLocations();
        this.initAutoComplete();
        this.updateChipContainerWidth();
        window.addEventListener("resize", ()=>this.updateChipContainerWidth());
        this.input.addEventListener("keydown", (event)=>{
            const { key } = event;
            const { query } = this.autoComplete.feedback;
            /**
       * FIXME: Fix the following bug:
       * - enter a location
       * - immediately after chip has been added, press backspace
       * - SHOULD: remove recently added chip
       * - IS: nothing happens
       * - NOTE: probably related to events.input.selection further down
       */ // Remove last chip when pressing backspace on empty input
            if (key === "Backspace" && query.length === 0) this.removeLastChip();
        });
    }
    /**
   * Format unsorted locations array to an array with regions / countries as keys
   */ formatLocations() {
        const locations = this.options.src;
        const regions = this.formatService.deriveRegions(locations);
        const regionObject = this.formatService.sortCountriesToRegions(regions, locations);
        const sortedArray = this.formatService.convertObjectToArray(regionObject);
        this.source = sortedArray;
    }
    initAutoComplete() {
        this.autoComplete = new (0, _autocompleteJsDefault.default)({
            selector: ()=>this.input,
            data: {
                src: this.source,
                keys: this.options.keys,
                cache: true,
                filter: (list)=>{
                    // Create Array from Set of all found items' unlocodes
                    const unlocodeArray = Array.from(new Set(list.map((item)=>item.value.unlocode)));
                    // Filter duplicates of found items
                    const filteredResults = unlocodeArray.map((unlocode)=>list.find((item)=>item.value.unlocode === unlocode));
                    return filteredResults;
                }
            },
            placeHolder: this.options.placeHolder,
            resultsList: {
                maxResults: 100,
                // Automatically select the first result when typing
                element: ()=>this.autoComplete.goTo(0)
            },
            resultItem: {
                highlight: true,
                element: (item, data)=>{
                    item.innerHTML = `<span>${data.value.label}</span>`;
                }
            },
            trigger: ()=>{
                return true;
            },
            events: {
                input: {
                    focus: ()=>{
                        this.autoComplete.start();
                    },
                    selection: (event)=>{
                        this.addChip(event.detail.selection.value);
                        this.autoComplete.input.value = "";
                    }
                }
            }
        });
    }
    addChipByUnlocode(unlocode) {
        const locationInfo = this.source.find((location)=>location.unlocode === unlocode);
        if (!locationInfo) return;
        this.addChip(locationInfo);
    }
    addChip(locationInfo) {
        if (this.chips.has(locationInfo.unlocode)) return;
        if (this.chips.size >= 1) this.removeLastChip();
        // Clone template
        const clone = this.template.content.cloneNode(true);
        const chipEl = clone.querySelector(SELECTOR_CHIPS_ITEM);
        // Update label
        const label = clone.querySelector("span");
        label.textContent = locationInfo.chipLabel || locationInfo.label;
        // Add event listener to remove Chip
        const closeBtn = clone.querySelector("svg");
        closeBtn.addEventListener("click", ()=>this.removeChip(chipEl, locationInfo.unlocode));
        // Add data attributes to receive values on form submit
        chipEl.setAttribute("data-value", locationInfo.unlocode);
        this.inputUnlo.value = locationInfo.unlocode;
        // Add chip to map to keep track of all selected values
        this.chips.set(locationInfo.unlocode, locationInfo.chipLabel || locationInfo.label);
        this.chipsContainer.append(clone);
        this.updateChipContainerWidth();
        this.checkChipAmount();
    }
    removeChip(target, unlocode) {
        // Remove from DOM
        target.remove();
        // Remove from Map
        this.chips.delete(unlocode);
        this.inputUnlo.value = "";
        this.updateChipContainerWidth();
        this.checkChipAmount();
    }
    removeLastChip() {
        if (this.chips.size === 0) return;
        const lastChip = Array.from([
            ...this.chips
        ]).pop();
        if (!lastChip) return;
        const [unlocode] = lastChip;
        const chipEl = this.chipsContainer.querySelector(`[data-value="${unlocode}"]`);
        if (!chipEl) return;
        this.removeChip(chipEl, unlocode);
    }
    updateChipContainerWidth() {
        const { width } = this.chipsContainer.getBoundingClientRect();
        const padding = Math.ceil(width) > 40 ? `${Math.ceil(width)}px` : "0px";
        this.el.style.setProperty("--padding", padding);
    }
    getSelectedLocations() {
        const selectedLocations = [
            ...this.chips.keys()
        ];
        return selectedLocations;
    }
    checkChipAmount() {
        this.el.querySelector(".autoComplete_wrapper").classList.toggle("-dirty", this.chips.size > 0);
    }
    select(unlocodes) {
        /**
     * Check for Regions first. If a match is found,
     * display the region as a single chip.
     */ const regionValue = this.source.find((location)=>location.unlocode === unlocodes.join(","));
        if (regionValue) {
            this.addChip(regionValue);
            return;
        }
        /**
     * If no region was matched, display each unlocode as a separate chip
     */ unlocodes.forEach((unlocode)=>{
            const locationValue = this.source.find((location)=>location.unlocode === unlocode);
            if (locationValue) this.addChip(locationValue);
        });
    }
}

},{"@tarekraafat/autocomplete.js":"hHonC","../utils/format.utils":"21k07","../styles/autocomplete.styles.css":"e0q2a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hHonC":[function(require,module,exports,__globalThis) {
var e, t;
e = this, t = function() {
    "use strict";
    function e(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
        }
        return n;
    }
    function t(t) {
        for(var n = 1; n < arguments.length; n++){
            var i = null != arguments[n] ? arguments[n] : {};
            n % 2 ? e(Object(i), !0).forEach(function(e) {
                r(t, e, i[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : e(Object(i)).forEach(function(e) {
                Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
            });
        }
        return t;
    }
    function n(e) {
        return n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, n(e);
    }
    function r(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e;
    }
    function i(e) {
        return function(e) {
            if (Array.isArray(e)) return s(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || o(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function o(e, t) {
        if (e) {
            if ("string" == typeof e) return s(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? s(e, t) : void 0;
        }
    }
    function s(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
        return r;
    }
    var u = function(e) {
        return "string" == typeof e ? document.querySelector(e) : e();
    }, a = function(e, t) {
        var n = "string" == typeof e ? document.createElement(e) : e;
        for(var r in t){
            var i = t[r];
            if ("inside" === r) i.append(n);
            else if ("dest" === r) u(i[0]).insertAdjacentElement(i[1], n);
            else if ("around" === r) {
                var o = i;
                o.parentNode.insertBefore(n, o), n.append(o), null != o.getAttribute("autofocus") && o.focus();
            } else r in n ? n[r] = i : n.setAttribute(r, i);
        }
        return n;
    }, c = function(e, t) {
        return e = String(e).toLowerCase(), t ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").normalize("NFC") : e;
    }, l = function(e, n) {
        return a("mark", t({
            innerHTML: e
        }, "string" == typeof n && {
            class: n
        })).outerHTML;
    }, f = function(e, t) {
        t.input.dispatchEvent(new CustomEvent(e, {
            bubbles: !0,
            detail: t.feedback,
            cancelable: !0
        }));
    }, p = function(e, t, n) {
        var r = n || {}, i = r.mode, o = r.diacritics, s = r.highlight, u = c(t, o);
        if (t = String(t), e = c(e, o), "loose" === i) {
            var a = (e = e.replace(/ /g, "")).length, f = 0, p = Array.from(t).map(function(t, n) {
                return f < a && u[n] === e[f] && (t = s ? l(t, s) : t, f++), t;
            }).join("");
            if (f === a) return p;
        } else {
            var d = u.indexOf(e);
            if (~d) return e = t.substring(d, d + e.length), d = s ? t.replace(e, l(e, s)) : t;
        }
    }, d = function(e, t) {
        return new Promise(function(n, r) {
            var i;
            return (i = e.data).cache && i.store ? n() : new Promise(function(e, n) {
                return "function" == typeof i.src ? i.src(t).then(e, n) : e(i.src);
            }).then(function(t) {
                try {
                    return e.feedback = i.store = t, f("response", e), n();
                } catch (e) {
                    return r(e);
                }
            }, r);
        });
    }, h = function(e, t) {
        var n = t.data, r = t.searchEngine, i = [];
        n.store.forEach(function(s, u) {
            var a = function(n) {
                var o = n ? s[n] : s, u = "function" == typeof r ? r(e, o) : p(e, o, {
                    mode: r,
                    diacritics: t.diacritics,
                    highlight: t.resultItem.highlight
                });
                if (u) {
                    var a = {
                        match: u,
                        value: s
                    };
                    n && (a.key = n), i.push(a);
                }
            };
            if (n.keys) {
                var c, l = function(e, t) {
                    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!n) {
                        if (Array.isArray(e) || (n = o(e)) || t && e && "number" == typeof e.length) {
                            n && (e = n);
                            var r = 0, i = function() {};
                            return {
                                s: i,
                                n: function() {
                                    return r >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[r++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: i
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var s, u = !0, a = !1;
                    return {
                        s: function() {
                            n = n.call(e);
                        },
                        n: function() {
                            var e = n.next();
                            return u = e.done, e;
                        },
                        e: function(e) {
                            a = !0, s = e;
                        },
                        f: function() {
                            try {
                                u || null == n.return || n.return();
                            } finally{
                                if (a) throw s;
                            }
                        }
                    };
                }(n.keys);
                try {
                    for(l.s(); !(c = l.n()).done;)a(c.value);
                } catch (e) {
                    l.e(e);
                } finally{
                    l.f();
                }
            } else a();
        }), n.filter && (i = n.filter(i));
        var s = i.slice(0, t.resultsList.maxResults);
        t.feedback = {
            query: e,
            matches: i,
            results: s
        }, f("results", t);
    }, m = "aria-expanded", b = "aria-activedescendant", y = "aria-selected", v = function(e, n) {
        e.feedback.selection = t({
            index: n
        }, e.feedback.results[n]);
    }, g = function(e) {
        e.isOpen || ((e.wrapper || e.input).setAttribute(m, !0), e.list.removeAttribute("hidden"), e.isOpen = !0, f("open", e));
    }, w = function(e) {
        e.isOpen && ((e.wrapper || e.input).setAttribute(m, !1), e.input.setAttribute(b, ""), e.list.setAttribute("hidden", ""), e.isOpen = !1, f("close", e));
    }, O = function(e, t) {
        var n = t.resultItem, r = t.list.getElementsByTagName(n.tag), o = !!n.selected && n.selected.split(" ");
        if (t.isOpen && r.length) {
            var s, u, a = t.cursor;
            e >= r.length && (e = 0), e < 0 && (e = r.length - 1), t.cursor = e, a > -1 && (r[a].removeAttribute(y), o && (u = r[a].classList).remove.apply(u, i(o))), r[e].setAttribute(y, !0), o && (s = r[e].classList).add.apply(s, i(o)), t.input.setAttribute(b, r[t.cursor].id), t.list.scrollTop = r[e].offsetTop - t.list.clientHeight + r[e].clientHeight + 5, t.feedback.cursor = t.cursor, v(t, e), f("navigate", t);
        }
    }, A = function(e) {
        O(e.cursor + 1, e);
    }, k = function(e) {
        O(e.cursor - 1, e);
    }, L = function(e, t, n) {
        (n = n >= 0 ? n : e.cursor) < 0 || (e.feedback.event = t, v(e, n), f("selection", e), w(e));
    };
    function j(e, n) {
        var r = this;
        return new Promise(function(i, o) {
            var s, u;
            return s = n || ((u = e.input) instanceof HTMLInputElement || u instanceof HTMLTextAreaElement ? u.value : u.innerHTML), function(e, t, n) {
                return t ? t(e) : e.length >= n;
            }(s = e.query ? e.query(s) : s, e.trigger, e.threshold) ? d(e, s).then(function(n) {
                try {
                    return e.feedback instanceof Error ? i() : (h(s, e), e.resultsList && function(e) {
                        var n = e.resultsList, r = e.list, i = e.resultItem, o = e.feedback, s = o.matches, u = o.results;
                        if (e.cursor = -1, r.innerHTML = "", s.length || n.noResults) {
                            var c = new DocumentFragment;
                            u.forEach(function(e, n) {
                                var r = a(i.tag, t({
                                    id: "".concat(i.id, "_").concat(n),
                                    role: "option",
                                    innerHTML: e.match,
                                    inside: c
                                }, i.class && {
                                    class: i.class
                                }));
                                i.element && i.element(r, e);
                            }), r.append(c), n.element && n.element(r, o), g(e);
                        } else w(e);
                    }(e), c.call(r));
                } catch (e) {
                    return o(e);
                }
            }, o) : (w(e), c.call(r));
            function c() {
                return i();
            }
        });
    }
    var S = function(e, t) {
        for(var n in e)for(var r in e[n])t(n, r);
    }, T = function(e) {
        var n, r, i, o = e.events, s = (n = function() {
            return j(e);
        }, r = e.debounce, function() {
            clearTimeout(i), i = setTimeout(function() {
                return n();
            }, r);
        }), u = e.events = t({
            input: t({}, o && o.input)
        }, e.resultsList && {
            list: o ? t({}, o.list) : {}
        }), a = {
            input: {
                input: function() {
                    s();
                },
                keydown: function(t) {
                    !function(e, t) {
                        switch(e.keyCode){
                            case 40:
                            case 38:
                                e.preventDefault(), 40 === e.keyCode ? A(t) : k(t);
                                break;
                            case 13:
                                t.submit || e.preventDefault(), t.cursor >= 0 && L(t, e);
                                break;
                            case 9:
                                t.resultsList.tabSelect && t.cursor >= 0 && L(t, e);
                                break;
                            case 27:
                                t.input.value = "", w(t);
                        }
                    }(t, e);
                },
                blur: function() {
                    w(e);
                }
            },
            list: {
                mousedown: function(e) {
                    e.preventDefault();
                },
                click: function(t) {
                    !function(e, t) {
                        var n = t.resultItem.tag.toUpperCase(), r = Array.from(t.list.querySelectorAll(n)), i = e.target.closest(n);
                        i && i.nodeName === n && L(t, e, r.indexOf(i));
                    }(t, e);
                }
            }
        };
        S(a, function(t, n) {
            (e.resultsList || "input" === n) && (u[t][n] || (u[t][n] = a[t][n]));
        }), S(u, function(t, n) {
            e[t].addEventListener(n, u[t][n]);
        });
    };
    function E(e) {
        var n = this;
        return new Promise(function(r, i) {
            var o, s, u;
            if (o = e.placeHolder, u = {
                role: "combobox",
                "aria-owns": (s = e.resultsList).id,
                "aria-haspopup": !0,
                "aria-expanded": !1
            }, a(e.input, t(t({
                "aria-controls": s.id,
                "aria-autocomplete": "both"
            }, o && {
                placeholder: o
            }), !e.wrapper && t({}, u))), e.wrapper && (e.wrapper = a("div", t({
                around: e.input,
                class: e.name + "_wrapper"
            }, u))), s && (e.list = a(s.tag, t({
                dest: [
                    s.destination,
                    s.position
                ],
                id: s.id,
                role: "listbox",
                hidden: "hidden"
            }, s.class && {
                class: s.class
            }))), T(e), e.data.cache) return d(e).then(function(e) {
                try {
                    return c.call(n);
                } catch (e) {
                    return i(e);
                }
            }, i);
            function c() {
                return f("init", e), r();
            }
            return c.call(n);
        });
    }
    function x(e) {
        var t = e.prototype;
        t.init = function() {
            E(this);
        }, t.start = function(e) {
            j(this, e);
        }, t.unInit = function() {
            if (this.wrapper) {
                var e = this.wrapper.parentNode;
                e.insertBefore(this.input, this.wrapper), e.removeChild(this.wrapper);
            }
            var t;
            S((t = this).events, function(e, n) {
                t[e].removeEventListener(n, t.events[e][n]);
            });
        }, t.open = function() {
            g(this);
        }, t.close = function() {
            w(this);
        }, t.goTo = function(e) {
            O(e, this);
        }, t.next = function() {
            A(this);
        }, t.previous = function() {
            k(this);
        }, t.select = function(e) {
            L(this, null, e);
        }, t.search = function(e, t, n) {
            return p(e, t, n);
        };
    }
    return function e(t) {
        this.options = t, this.id = e.instances = (e.instances || 0) + 1, this.name = "autoComplete", this.wrapper = 1, this.threshold = 1, this.debounce = 0, this.resultsList = {
            position: "afterend",
            tag: "ul",
            maxResults: 5
        }, this.resultItem = {
            tag: "li"
        }, function(e) {
            var t = e.name, r = e.options, i = e.resultsList, o = e.resultItem;
            for(var s in r)if ("object" === n(r[s])) for(var a in e[s] || (e[s] = {}), r[s])e[s][a] = r[s][a];
            else e[s] = r[s];
            e.selector = e.selector || "#" + t, i.destination = i.destination || e.selector, i.id = i.id || t + "_list_" + e.id, o.id = o.id || t + "_result", e.input = u(e.selector);
        }(this), x.call(this, e), E(this);
    };
}, module.exports = t();

},{}],"21k07":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormatService", ()=>FormatService);
class FormatService {
    constructor(){}
    /**
   * deriveRegions
   * @description Get unique regions from an array of locations
   * @param {Location[]} locations  Array of locations
   * @returns {string[]}            Array of region labels
   */ deriveRegions(locations) {
        const regions = new Set();
        locations.forEach((location)=>{
            regions.add(location.region);
        });
        return Array.from(regions);
    }
    /**
   * deriveCountries
   * @description Derive countries from an array of locations
   * @param {Location[]} locations  Array of locations
   * @returns {Country[]}           Array of countries
   */ deriveCountries(locations) {
        const countries = new Set();
        locations.forEach((location)=>countries.add(location.country));
        const unsorted = Array.from(countries).map((country)=>{
            const locationsForCountry = locations.filter((location)=>location.country === country);
            return {
                score: this.calculateScore(locationsForCountry),
                label: country,
                labelAlt: locationsForCountry.find((_country)=>_country.country === country)?.countryAlt,
                unlocode: locationsForCountry[0].unlocode.slice(0, 2),
                locations: locationsForCountry
            };
        });
        const sorted = unsorted.sort((a, b)=>b.score - a.score);
        return sorted;
    }
    /**
   * sortCountriesToRegions
   * @description Assign countries to their corresponding regions
   * @param {string[]} regions      Array of regions
   * @param {Location[]} locations  Array of locations
   * @returns {RegionObject}        Object with regions as keys
   */ sortCountriesToRegions(regions, locations) {
        const objectWithRegions = {};
        regions.forEach((region)=>{
            const locationsForRegion = locations.filter((location)=>location.region === region);
            objectWithRegions[region] = {
                score: this.calculateScore(locationsForRegion),
                countries: this.deriveCountries(locationsForRegion),
                label: region,
                labelAlt: locationsForRegion.find((_region)=>_region.region === region)?.regionAlt
            };
            delete objectWithRegions[region].locations;
        });
        return objectWithRegions;
    }
    /**
   * convertObjectToArray
   * @description Convert a RegionObject to a sorted array of regions, countries and locations sorted by score
   * @param {RegionObject} regionObject   Object with regions as keys
   * @returns {AutocompleteLocation[]}    Array of regions, countries and locations sorted by score
   */ convertObjectToArray(regionObject) {
        const sortedArray = [];
        const sorted = Array.from(Object.values(regionObject)).sort((a, b)=>b.score - a.score);
        sorted.forEach((region)=>{
            // Add Region to Array
            const regionUnlocodes = region.countries.map((country)=>country.unlocode);
            sortedArray.push({
                unlocode: regionUnlocodes.join(","),
                label: region.label,
                searchLabel: region.label,
                searchLabelAlt: region.labelAlt,
                region: region.label,
                score: region.score
            });
            // Add Country to Array
            region.countries.forEach((country)=>{
                sortedArray.push({
                    unlocode: country.unlocode,
                    label: `${region.label}, ${country.label}`,
                    searchLabel: `${region.label} ${country.label}`,
                    searchLabelAlt: `${region.labelAlt} ${country.labelAlt}`,
                    chipLabel: country.label,
                    region: region.label,
                    country: country.label,
                    score: country.score
                });
                // Add Locations to Array
                country.locations.forEach((location)=>{
                    sortedArray.push({
                        unlocode: location.unlocode,
                        label: `${region.label}, ${location.label}`,
                        searchLabel: `${region.label} ${country.label} ${location.label}`,
                        searchLabelAlt: `${region.labelAlt} ${country.labelAlt} ${location.labelAlt}`,
                        chipLabel: location.label,
                        region: region.label,
                        country: country.label,
                        score: location.score
                    });
                });
            });
        });
        return sortedArray;
    }
    /**
   * calculateScore
   * @description Calculate the score of a Region / Country based on the score of its locations
   * @param {Location} locations  Locations to calculate the score from
   * @returns {number}            Cumulated score of the region / country
   */ calculateScore(locations) {
        return locations.reduce((acc, curr)=>{
            return acc + curr.score;
        }, 0);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e0q2a":[function() {},{}],"dQBzS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "docReady", ()=>docReady);
function docReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["eaVp8","7mLUj"], "7mLUj", "parcelRequire94c2")

//# sourceMappingURL=searchBar.js.map
